import { MutationHookOptions, useMutation } from '@apollo/client';

import { DeleteSavedSearchDocument, DeleteSavedSearchMutation, DeleteSavedSearchMutationVariables } 
  from './savedSearches.gql';

const defaultOptions = {} as const;

export function useDeleteSavedSearchMutation(
  baseOptions?: MutationHookOptions<
  DeleteSavedSearchMutation,
  DeleteSavedSearchMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return useMutation<
  DeleteSavedSearchMutation,
  DeleteSavedSearchMutationVariables
  >(DeleteSavedSearchDocument, options);
}